<template>
  <div class="view_box" :class="isAni ? 'ani':''">
    <div class="title">营销效果回顾</div>
    <div>今年<span class="font_color">&nbsp;{{ data.bestRoiName }}&nbsp;</span>，这次营销ROI最高，达到<span class="font_color">&nbsp;{{ data.bestRoiVal }}&nbsp;</span></div>
    <div>触达人数<span class="font_color">&nbsp;{{ data.bestReachNum }}&nbsp;</span>人，触达率高达：<span class="font_color">{{ data.bestReachRate }}%&nbsp;</span></div>
    <div>此次营销活动共计带来GMV<span class="font_color">&nbsp;{{ data.bestRoiMoney }}&nbsp;</span>元</div>
    <div style="margin-bottom: 24px;">那一刻，为满意结果而喝彩！</div>
    <div style="width: 300px; word-break: break-all;">今年<span class="font_color">&nbsp;{{ data.lessRoiName }}&nbsp;</span>，这次营销ROI最低，仅只有<span class="font_color">&nbsp;{{ data.lessRoiVal }}&nbsp;</span></div>
    <div style="margin-bottom: 24px;">明年，相信一定会找到办法改进！</div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {
    isAni:{
      type:Boolean,
      default:true,
    },
    data: {
      type: Object,
      default: ()=> {}
    }
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
@keyframes view_box_s {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.ani{
  animation: view_box_s 1.5s ease-in;
  animation-fill-mode: both;
  border-radius: 16px;
}
.view_box {
  position: relative;
  width: 100%;
  height: 100%;
  // border-radius: 16px;
  padding: 50px;
  font-size: 14px;
  color: #000000;
  line-height: 16px;
  font-family: PingFang SC;
  background-image: url("../../assets/images/yearReport/P3.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;


  div {
    font-family: PingFang SC;
    width: 100%;
    margin-bottom: 12px;
  }

  .title {
    font-size: 24px;
    font-weight: bold;
    line-height: 28px;
    margin-bottom: 30px;
  }

  .font_color {
    color: #0b79ff;
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;
  }
}
</style>
